import React, {FC, ReactElement, ReactNode, useState} from "react"
import styled, {css} from "styled-components"
import Flex from "../Flex"

interface Tab {
  pill: ReactNode
  content?: ReactElement
  onClick?: () => void
  isTabActive?: boolean
}

interface Props {
  tabs: Tab[]
}

interface TabProps {
  isActive: boolean
}

const TabPills: FC<Props> = ({tabs}) => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabClick = (index: number, onClick?: () => void) => {
    setActiveTab(index)
    if (onClick) onClick()
  }

  return (
    <>
      <Flex gap={1}>
        {tabs.map((tab, index) => {
          const isActive = tab.isTabActive ?? activeTab === index

          return (
            <Tab key={index} isActive={isActive} onClick={() => handleTabClick(index, tab.onClick)}>
              {tab.pill}
            </Tab>
          )
        })}
      </Flex>
      <Flex marginTop={1}>{tabs[activeTab]?.content}</Flex>
    </>
  )
}

const Tab = styled.div<TabProps>`
  ${({theme, isActive}) => css`
    display: flex;
    align-items: center;
    height: 45px;
    border-radius: 27px;
    border: 0.5px solid ${theme.colors.greys.grey12};
    box-shadow: ${isActive ? theme.shadows.high : theme.shadows.mid};
    background-color: ${isActive ? theme.colors.primary2 : theme.colors.greys.white};
    cursor: pointer;

    * {
      color: ${isActive ? theme.colors.greys.white : theme.colors.greys.black};
      ${isActive && `font-family: ${theme.font.semibold}`}
    }
  `}
`

export default TabPills
